export default __webpack_public_path__ + "static/media/ies_Lutron.2f1d6f6a.png";